import { useState, useEffect } from 'react';

const useResponsive = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: width < 768,       // Typical mobile breakpoint (e.g., Tailwind's md)
    isTablet: width >= 768 && width < 1024, // Typical tablet breakpoint (e.g., Tailwind's lg)
    isDesktop: width >= 1024};
};

export default useResponsive;
